import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LeaguesPageRoutingModule } from './leagues-routing.module';

import { LeaguesPage } from './leagues.page';
import { EmptyPageModule } from '../empty-page/empty-page.module';
import { TranslateModule } from '@ngx-translate/core';
import { TieScorecardModule } from '../ties/tie-details/tie-scorecard/tie-scorecard.module';
import { CreateLeagueComponent} from './create-league/create-league.component';
import { SelectOrganisationComponent } from '../select-organisation/select-organisation.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        LeaguesPageRoutingModule,
        EmptyPageModule,
        TranslateModule.forChild(),
        SelectOrganisationComponent
    ],
    declarations: [
        LeaguesPage,
        CreateLeagueComponent
    ]
})
export class LeaguesPageModule { }
